import { productGridCardStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductGridCard";
import { productImageStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import {actionsStyles} from "@insite/content-library/Widgets/ProductList/ProductListTable";
import DataTableCellBase from "@insite/mobius/DataTable/DataTableCellBase";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

actionsStyles.actionsCell = {
    css: css`
        position: sticky;
        right: 0;
        width: 200px;
        min-width: 150px;
        background-color: inherit;
        background-clip: padding-box;
        >div[class^="sc"] {
            >div[class^="sc"] {
                &:last-child{
                    text-align: right;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        css`
                            text-align: left;
                        `,
                        null,
                        null,
                        null,
                    ],"max",)}
                }
            }
        }
    `,
}

actionsStyles.rightColumnGridItem = {
    width: [8, 8, 8, 9, 9],
    css: css`
        flex-direction: column;
        div[data-test-selector^="productListProductImage"] {
            display: none;
        }
    `,
}

actionsStyles.productImageStyles = {
    compareCheckbox: {
        css: css`
            align-self: start;
            padding-top: 15px;
            padding-left: 15px;
        `,
    },
}

actionsStyles.wrapper = {
    css: css`
        overflow: auto;
        max-width: 100%;
        flex-basis: 100%;
        border-left: 1px solid ${getColor("common.border")};
        border-right: 1px solid ${getColor("common.border")};
    `,
}

actionsStyles.dataTable = {
    css: css`
    >thead {
        tr[class^="DataTableHeadStyle"] {
            border-top: 1px solid ${getColor("common.border")};
            >${DataTableCellBase}{
                background: ${getColor("info.contrast")};
                border-right: 1px solid ${getColor("common.border")};
                &:last-child{
                    border-right: none;
                }
                >${TypographyStyle}{
                    font-size: 14px;
                    color: ${getColor("secondary")};
                }
            }
        }
    }
    >tbody {
        tr[class^="DataTableRowStyle"] {
            &:nth-child(even){
                background: ${getColor("common.background")}; 
            }
            >${DataTableCellBase}{
                background: ${getColor("common.background")}; 
                border-right: 1px solid ${getColor("common.border")};
                &:last-child{
                    border-right: none;
                }
                >${TypographyStyle}{
                    font-size: 14px;
                    color: ${getColor("secondary")};
                    white-space: nowrap;
                }
            }
        }
    }
    `
}

productImageStyles.compareCheckbox = {
    css: css`
        align-self: center;
        padding-top: 0px;
        cursor: pointer;
        display: none;
        > ${TypographyStyle} {
            font-size: 14px;
            line-height: 24px;
            color: ${getColor("secondary")};
        }
    `,
};
productImageStyles.productImage = {
    linkWrappingImage: {
        css: css`
            width: 100%;
            height: 90%;
            &:focus {
                outline: none;
            }
        `,
    },
    img: {
        css: css`
            width: 100%;
            height: 90%;
        `,
    },
    image: {
        css: css`
            img {
                min-width: 100%;
            }
        `,
    },
};

productImageStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        height: inherit;
    `,
};

productGridCardStyles.wrapper!.css = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding-bottom: 0px;
`;
productGridCardStyles.imageWrapper = {
    css: css`
        margin: 8px auto;
        padding: 0px;
        height: 220px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    width: 160px;
                    height: 180px;
                `,
                css`
                    width: 100%;
                `,
                null,
            ])}
    `,
};
